import React, { useMemo } from 'react'
import GenericBinarySrcGraph from '../../GeneralBinarySrcGraph/GenericBinarySrcGraph'
import { WithTranslation, withTranslation } from 'react-i18next'
import { Flex } from '@mv-submodules/mvlabs-components-fe/ui/components'
import { Direction } from '@mv-submodules/mvlabs-components-fe/ui/components/Flex/Flex'
import { Workshift } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/workshift'

interface Props extends WithTranslation {
  id: string
  plant: string
  workShift: Workshift
}

const COLORS: { buffers: Record<number, string>; thresholds: Record<number, string> } = {
  buffers: {
    1: '#00B0F0',
    2: '#FF99CC',
    3: '#7B17D9',
    4: '#FED283',
    5: '#87C287',
  },
  thresholds: { 1: '#FF0000' },
}

const BUFFERS_ASSET_IDS: Record<number, string> = {
  1: 'IBSGN5PHK0LR8VII',
  2: 'IBSGN5PHK0N72MZJ',
  3: 'IDF074',
  4: 'IDF084',
  5: 'IBSGN5PK9QL0FEJQ',
}

const BufferFillGraph = (props: Props) => {
  const { id, plant, workShift, t } = props

  const BufferGraphs = useMemo(() => {
    return Object.entries(BUFFERS_ASSET_IDS).map(([n, assetId]) => {
      const bufferIndex = Number(n)
      return (
        <GenericBinarySrcGraph
          key={assetId}
          id={assetId}
          plant={plant}
          workShift={workShift}
          title={t(`plantAnalysis.vecoplant.buffer${n}FillTitle`)}
          measures={[
            {
              slug: `buffer${n}VAlues`,
              id: 'MAT_ACT_LEV_calc',
              representation: 'line',
              color: COLORS.buffers[bufferIndex],
              unitOfMeasurement: 'm',
              label: t('plantAnalysis.labels.bufferVAlues'),
            },
            {
              slug: `buffer${n}Threshold`,
              id: 'MAT_LEV_INT_STA',
              representation: 'line',
              color: COLORS.thresholds[1],
              unitOfMeasurement: 'm',
              label: t('plantAnalysis.labels.bufferThreshold'),
            },
          ]}
        />
      )
    })
  }, [])

  return (
    <Flex direction={Direction.column} spaceSize={'lg'}>
      <GenericBinarySrcGraph
        id={id}
        plant={plant}
        workShift={workShift}
        title={t('plantAnalysis.buffer.bufferLoadingTitle')}
        measures={[
          { slug: 'bufferLoadedWithF015', id: 'BUF_BOX_SEL_F015', representation: 'time-bar' },
          { slug: 'bufferLoadedWithF070', id: 'BUF_BOX_SEL_F070', representation: 'time-bar' },
        ]}
      />
      {BufferGraphs}
    </Flex>
  )
}

export default withTranslation()(BufferFillGraph)
